// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.selectItem) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.selectItem = true;

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  function onClick(e) {
    if (!e.target.closest) return;

    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    var listContainer = link.closest('[data-tracking-list-id]');
    if (!listContainer) return;

    var handleMatch = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return;
    var handle = handleMatch[1];

    var cache = Tracking.productCache || {};
    var item = cache[handle];
    if (!item) return;

    // The clicked container is only a CANDIDATE list. If this product was already
    // seen somewhere else in the session, Tracking.applyAttribution keeps that
    // first-seen list — select_item reports where the product was discovered,
    // not where it happened to be clicked.
    var enrichedItem = Object.assign({}, item, {
      item_list_id: listContainer.getAttribute('data-tracking-list-id') || '',
      item_list_name: listContainer.getAttribute('data-tracking-list-name') || '',
    });
    if (typeof Tracking.applyAttribution === 'function') {
      Tracking.applyAttribution(enrichedItem);
    }

    push({
      event: 'select_item',
      ecommerce: {
        item_list_id: enrichedItem.item_list_id || '',
        item_list_name: enrichedItem.item_list_name || '',
        items: [enrichedItem],
      },
    });
  }

  document.addEventListener('click', onClick, true);
})();
// custom code end